var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationSubmit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56415 4.10938H6.09975C4.86754 4.10938 3.85938 5.11754 3.85938 6.34975V25.6729C3.85938 26.9051 4.86754 27.9133 6.09975 27.9133H19.822C20.1581 27.9133 20.4941 27.8573 20.7742 27.6893",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3574 4.10938H19.8218C21.054 4.10938 22.0622 5.11754 22.0622 6.34975V13.3509",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3579 3.21399V4.95028C17.3579 5.6784 16.7978 6.2385 16.0697 6.2385H9.85267C9.12455 6.2385 8.56445 5.6784 8.56445 4.95028V3.21399C8.56445 2.48587 9.12455 1.92578 9.85267 1.92578H16.0697C16.7978 1.92578 17.3579 2.48587 17.3579 3.21399Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40443 18.3923H7.72416C7.3881 18.3923 7.16406 18.1682 7.16406 17.8322V16.1519C7.16406 15.8158 7.3881 15.5918 7.72416 15.5918H9.40443C9.74049 15.5918 9.96453 15.8158 9.96453 16.1519V17.8322C9.96453 18.1682 9.68448 18.3923 9.40443 18.3923Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40443 12.4001H7.72416C7.3881 12.4001 7.16406 12.176 7.16406 11.84V10.1597C7.16406 9.82365 7.3881 9.59961 7.72416 9.59961H9.40443C9.74049 9.59961 9.96453 9.82365 9.96453 10.1597V11.84C9.96453 12.12 9.68448 12.4001 9.40443 12.4001Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40443 24.4411H7.72416C7.3881 24.4411 7.16406 24.2171 7.16406 23.881V22.2007C7.16406 21.8647 7.3881 21.6406 7.72416 21.6406H9.40443C9.74049 21.6406 9.96453 21.8647 9.96453 22.2007V23.881C9.96453 24.2171 9.68448 24.4411 9.40443 24.4411Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 9.82422H19.4862",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 12.1211H16.1816",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8374 15.873H12.541",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4932 18.1699H12.541",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 21.9199H12.541",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 24.2168H13.6612",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.918 22.3144H26.9343C27.3264 22.3144 27.6064 21.9783 27.6064 21.5302C27.6064 21.0821 27.3264 20.7461 26.9343 20.7461H25.366",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0781 23.8827H26.5425C26.9346 23.8827 27.2146 23.5467 27.2146 23.0986C27.2146 22.6505 26.9346 22.3145 26.5425 22.3145H24.9743",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3108 20.7465H27.3271C27.7192 20.7465 27.9992 20.4104 27.9992 19.9624C27.9992 19.5143 27.7192 19.1782 27.3271 19.1782H22.6783C22.6783 19.1782 24.3026 17.666 23.0704 14.9215C22.9584 14.6415 22.5663 14.4174 22.2303 14.5295C21.8942 14.6415 21.6702 14.9215 21.7262 15.2576C21.7262 15.8737 21.6702 16.8258 21.2221 17.834C20.83 18.6741 19.9899 19.1782 19.0938 19.1782V24.6111L19.7659 25.1712C19.9339 25.3392 20.2139 25.3953 20.438 25.3953H25.6468C26.0389 25.3953 26.3189 25.0592 26.3189 24.6111C26.3189 24.1631 26.0389 23.827 25.6468 23.827H24.0786",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5726 26.1787H18.0849C18.645 26.1787 19.093 25.7306 19.093 25.1705V18.9535C19.093 18.3934 18.645 17.9453 18.0849 17.9453H16.5726C16.0125 17.9453 15.5645 18.3934 15.5645 18.9535V25.1705C15.6205 25.7306 16.0685 26.1787 16.5726 26.1787Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSubmit);
export default __webpack_public_path__ + "static/media/applicationSubmit.2721ec62d3e01583fc1469230a98a4bb.svg";
export { ForwardRef as ReactComponent };